module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.pageType === 'unsubscribe') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('unsubscribe_title')))]), _vm._v(" "), _c('div', {
    class: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.unsubscribe
    }
  }, [_vm._v(_vm._s(_vm.$t('unsubscribe_button')))])]) : _vm._e(), _vm._v(" "), (_vm.pageType === 'resubscribe') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('resubscribe_title')))]), _vm._v(" "), _c('div', {
    class: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.resubscribe
    }
  }, [_vm._v(_vm._s(_vm.$t('resubscribe_button')))])]) : _vm._e(), _vm._v(" "), (_vm.pageType === 'restored') ? _c('div', {
    staticClass: "content restored"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('restored_title')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9a732ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/subscribeManage/subscribeManage.vue
// module id = 1400
// module chunks = 1